import {
  Button, ButtonVariant, Flex, FlexItem,
  Grid,
  GridItem,
  Toolbar,
  ToolbarContent,
  ToolbarItem
} from '@patternfly/react-core';
import React from 'react';
import SimpleTable from '../Common/SimpleTable/SimpleTable';
import { useTranslation } from '../../localization/useTranslation';
import './ChosenSignals.css';

const ChosenSignals = ({
  handleRemoveAllSignals,
  checkedTreeItems,
  handleApplySignals,
  disableApplyBtn,
  tableData,
  columns
}) => {
  const T = useTranslation();

  return (
    <>
      <Toolbar>
        <ToolbarContent>
          <Grid>
            <GridItem span={12} style={{ marginTop: '1em' }}>
              <Flex className="button-container">
                <FlexItem>
                  <ToolbarItem>
                    <Button variant={ButtonVariant.primary} onClick={handleRemoveAllSignals} isDisabled={checkedTreeItems.length === 0}>{ T.signals.removeAll }</Button>
                  </ToolbarItem>
                </FlexItem>
                <FlexItem>
                  <ToolbarItem>
                    <Button variant={ButtonVariant.primary} onClick={handleApplySignals} isDisabled={disableApplyBtn}>{ T.common.apply }</Button>
                  </ToolbarItem>
                </FlexItem>
              </Flex>
            </GridItem>
          </Grid>
        </ToolbarContent>
      </Toolbar>
      <SimpleTable
        data={tableData}
        columns={columns}
        tableClassName={'signals-table'}
        compact
      />
    </>
  );
};

export default ChosenSignals;
